import { render, staticRenderFns } from "./CopyMoveCalendarModal.vue?vue&type=template&id=dbc3728c&scoped=true"
import script from "./CopyMoveCalendarModal.vue?vue&type=script&lang=js"
export * from "./CopyMoveCalendarModal.vue?vue&type=script&lang=js"
import "./CopyMoveCalendarModal.vue?vue&type=style&index=0&id=dbc3728c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc3728c",
  null
  
)

export default component.exports